import { produce } from 'immer';

import { USERS_ACTION_TYPE } from '../actions';

const initialState = {};

const usersReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case USERS_ACTION_TYPE.GET_USERS:
        return payload || initialState;

      case USERS_ACTION_TYPE.GET_USER:
      case USERS_ACTION_TYPE.CREATE_USER:
      case USERS_ACTION_TYPE.EDIT_USER:
        draft[payload.id] = payload;
        break;

      case USERS_ACTION_TYPE.DELETE_USER:
        delete draft[meta.id];
        break;

      case USERS_ACTION_TYPE.SET_USER_PROPERTY: {
        const targetUser = draft[meta.userId];

        if (!targetUser) {
          break;
        }

        if (!targetUser.userProperties) {
          targetUser.userProperties = { userId: meta.userId, userProperties: [] };
        }

        if (!targetUser.userProperties.userProperties) {
          targetUser.userProperties.userProperties = [];
        }

        const properties = targetUser.userProperties.userProperties;
        const existing = properties.find(({ name }) => name === payload.name);

        if (existing) {
          existing.value = payload.value;
          break;
        }

        properties.push({ name: payload.name, value: payload.value });

        break;
      }

      case USERS_ACTION_TYPE.RESET_USERS_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default usersReducer;
